import { ICommentsAndObservations } from '../../../../types/global';
import CommentImage from '../CommentImage/CommentImage';
import './ExistingComment.scss';

const ExistingComment = ({ comment, index }: { comment: ICommentsAndObservations; index: number }) => {
  const { id, comments, user, createdAt, mentionsData, image } = comment;
  const mentions = mentionsData?.map(mention => mention.mentioneeUser);
  const onlyDate = new Date(createdAt ?? new Date())?.toLocaleDateString();
  const onlyHour = new Date(createdAt ?? new Date())?.toLocaleTimeString('es-ES', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });

  const onlyTimeZone = new Date(createdAt ?? new Date())?.toLocaleTimeString('es-ES', {
    timeZoneName: 'short'
  });

  return (
    <div className="existingComment" key={`comment-${id}-index-${index}`}>
      <p className="userName">{!!user ? user : 'Usuario no identificado'}</p>
      {mentions && mentions?.length > 0 && (
        <div className="mentions">
          {mentions?.map((mention, index) => (
            <span key={`mention${mention} - ${index}`} className="mention">
              @{mention}
            </span>
          ))}
        </div>
      )}
      {comments && <p className="message">{comments}</p>}
      {image?.imageUrl && <CommentImage imageUrl={image?.imageUrl} />}
      {createdAt && (
        <div className="contentMoreInfo">
          <p className="date">
            {onlyDate} {onlyHour}
          </p>
          <p className="timeZone">({onlyTimeZone})</p>
        </div>
      )}
    </div>
  );
};

export default ExistingComment;
